import React from "react";
import { FPTwoBackgroundFullScreenView } from "../../Simple/FPTwoBackgroundFullScreenView/FPTwoBackgroundFullScreenView";
import { FrontColors } from "../../../../models/FrontColors";
import { SpacingRow } from "../../../BuildingBlocks/SpacingRow";
import { FPSimpleLogo } from "../../Simple/FPSimpleLogo/FPSimpleLogo";
import { SpacingColumn } from "../../../BuildingBlocks/SpacingColumn";
import { FPLandingTitle } from "../../Simple/FPLandingTitle/FPLandingTitle";
import { FPMarketingParagraph } from "../../Simple/FPMarketingParagraph/FPMarketingParagraph";
import { FPMarketingHelplineCTA } from "../../Complex/FPMarketingHelplineCTA/FPMarketingHelplineCTA";
import { FPMarketingParagraphColumn } from "../../Complex/FPMarketingParagraphColumn/FPMarketingParagraphColumn";
import { TProbateLeadForm } from "../../../../../../domain/codecs/form/ProbateLeadForm";
import { FrontIcon } from "../../../Front/Simple/FrontIcon/FrontIcon";
import { WeightBold } from "../../../WeightBold/WeightBold";
import { Shape } from "../../../BuildingBlocks/Shape";
import { MaxWidth } from "../../../BuildingBlocks/MaxWidth";
import { Background } from "../../../BuildingBlocks/Background";
import { Sticky } from "../../../BuildingBlocks/Sticky";
import { Padding } from "../../../BuildingBlocks/Padding";

type TLandingPageDesktopHeroProps = {
    form: TProbateLeadForm;
    onChange: (form: TProbateLeadForm) => void;
    onSubmit: (form: TProbateLeadForm) => void,
};

export const FPLandingPageDesktopHero = (props: React.PropsWithChildren<TLandingPageDesktopHeroProps>): JSX.Element => {

    return (
        <FPTwoBackgroundFullScreenView
            leftColor={FrontColors.PROBATE_0}
            rightColor={FrontColors.NEUTRAL_18}
            leftCutPoint="50%"
            rightCutPoint="50%"
            height="auto"
        >
            <SpacingRow 
                spacing={`160px`}
                childSize="1fr 1fr"
                alignItems="flex-start"
            >
                {/* COLUMN - LEFT */}
                <Background 
                    backgroundPosition={"relative"}
                    padding={`180px 0px 210px`}
                    height="2500px"
                >
                    <Sticky top="180px">
                        <SpacingColumn spacing={`40px`}>

                            <SpacingRow justifyContent="center">
                                <FPSimpleLogo 
                                    width={"95px"} 
                                />
                            </SpacingRow>
                            
                            <FPLandingTitle 
                                color={FrontColors.NEUTRAL_18}
                                align="center"
                                size={56}
                            >
                                Free <br/> Independent Probate Helpline
                            </FPLandingTitle>

                            <FPMarketingParagraph 
                                color={FrontColors.NEUTRAL_18}
                                align="center"
                                size={20}
                            >
                                Request a call back from our probate experts for free information & advice.
                            </FPMarketingParagraph>

                            <SpacingRow justifyContent="center">
                                <MaxWidth width="350px">
                                    <FPMarketingHelplineCTA
                                        form={props.form}
                                        coloursInverted={true}
                                        autoFocus={true}
                                        alignDisclaimer="center"
                                        name="landing-page-0__hero-view"
                                        disclaimer="*we can only call you during regular working hours, and will never use your number for any other purpose."
                                        onChange={props.onChange}
                                        onSubmit={props.onSubmit}
                                    />
                                </MaxWidth>
                            </SpacingRow>
                        </SpacingColumn>
                    </Sticky>
                </Background>

                {/* COLUMN - RIGHT */}
                <Background 
                    padding={`160px 0px 200px`}
                    width="480px"
                    height="2500px"
                >
                    <SpacingColumn spacing="130px">
                        <SpacingColumn spacing={`60px`}>
                            <SpacingRow justifyContent="center">
                                <FrontIcon
                                    iconName="lily"
                                    size={"84px"}
                                    colour={FrontColors.PROBATE_0}
                                />
                            </SpacingRow>

                            <FPMarketingParagraphColumn
                                size={22}
                                align={"center"}
                                spacing="30px"
                                paragraphs={[
                                    <>When someone you love passes away, you need time to <WeightBold>grieve.</WeightBold></>,
                                    <>Making sure their <WeightBold>inheritance</WeightBold> goes to the right place can feel <WeightBold>overwhelming.</WeightBold></>,
                                    <>You have their <WeightBold>home, money, belongings, pension, tax,</WeightBold> and more to consider.</>,
                                    <>This process is what we call <WeightBold>probate.</WeightBold></>
                                ]}
                            />
                        </SpacingColumn>
                    </SpacingColumn>
                    
                    <Sticky top="44px">
                        <Padding spacing="130px 0 0 0px">
                            <SpacingColumn spacing="130px">
                                <SpacingRow justifyContent="center">
                                <Shape 
                                    width="80px" 
                                    height="2px" 
                                    color={FrontColors.NEUTRAL_INK} 
                                />
                            </SpacingRow>

                            <FPMarketingParagraphColumn
                                size={22}
                                align={"center"}
                                spacing="30px"
                                paragraphs={[
                                    <>Let us <WeightBold>simplify</WeightBold> it for you.</>,
                                    <>We can give you <WeightBold>advice suited to your situation.</WeightBold></>,
                                    <><WeightBold>Avoid</WeightBold> the <WeightBold>confusion</WeightBold>, <WeightBold>mistakes</WeightBold>, and <WeightBold>hours of reading</WeightBold> you would have to do without our help.</>,
                                ]}
                            />
                            </SpacingColumn>
                        </Padding>
                    </Sticky>
                </Background>

            </SpacingRow>
        </FPTwoBackgroundFullScreenView>
    );
};
